import { render, staticRenderFns } from "./quality-check.vue?vue&type=template&id=736021ef"
import script from "./quality-check.vue?vue&type=script&lang=ts"
export * from "./quality-check.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports